import React from 'react'
import { Route, Switch } from 'react-router-dom'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/bankcard'
        render={(routeProps) => (
          <React.Fragment>
            {require('./AddBankAccount').default(routeProps)}
            {require('./AddBankCard').default(routeProps)}
            {require('./AddSessionBankCard').default(routeProps)}
            {require('./BindResult').default(routeProps)}
            {require('./ChannelUpdates').default(routeProps)}
            {require('./Main').default(routeProps)}
          </React.Fragment>
        )}
      />
    </Switch>
  )
}

export default AppRouter
